import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@/pages/service/core/api.service';

export interface LeadDTO {
  id: number;
  workflowId?: string;
  contactPhone?: string;
  contactName?: string;
  status?: string;
  stage?: string;
  createdAt?: string;
}

export interface LeadVendorDTO {
  id: number;
  vendorId: number;
  inventoryId?: number;
  status?: string;
  replyPayload?: string;
  respondedAt?: string;
}

@Injectable({ providedIn: 'root' })
export class LeadService {
  constructor(private api: ApiService) {}

  getLeads(phoneNumber: string): Observable<LeadDTO[]> {
    return this.api.get<LeadDTO[]>('/api/leads', { phoneNumber });
  }

  getLeadVendors(leadId: number): Observable<LeadVendorDTO[]> {
    return this.api.get<LeadVendorDTO[]>(`/api/leads/${leadId}/vendors`);
  }

  selectVendor(payload: { leadId: number; vendorId: number }): Observable<void> {
    return this.api.post<void>('/api/leads/select-vendor', payload);
  }

  assignLead(payload: { leadId: number; vendorId: number }): Observable<void> {
    return this.api.post<void>('/api/leads/assign', payload);
  }

  closeLead(leadId: number): Observable<void> {
    return this.api.post<void>(`/api/leads/${leadId}/close`, null);
  }
}
